import type { IntegrationRequestType } from './IntegrationRequest';

export enum IntegrationRequestStepId {
  READINESS = 'readiness',
  BRANCH_CODES = 'branch_codes',
  PREPARE = 'prepare',
  WEBHOOK_APPLY = 'webhook_apply',
  SYNC_TEST = 'sync_test',
  VERIFY_TEST = 'verify_test',
  SMOKE_TESTS = 'smoke_tests',
}

export const INTEGRATION_STEP_ORDER = Object.values(IntegrationRequestStepId);

export const INTEGRATION_STEPS_BY_TYPE: Record<IntegrationRequestType, IntegrationRequestStepId[]> = {
  API: INTEGRATION_STEP_ORDER,
  WEBHOOK: [IntegrationRequestStepId.READINESS, IntegrationRequestStepId.WEBHOOK_APPLY],
};

export const INTEGRATION_STEP_LABELS: Record<IntegrationRequestStepId, string> = {
  [IntegrationRequestStepId.READINESS]: 'Revisión de la solicitud',
  [IntegrationRequestStepId.BRANCH_CODES]: 'Códigos de sucursal',
  [IntegrationRequestStepId.PREPARE]: 'Credenciales y configuración',
  [IntegrationRequestStepId.WEBHOOK_APPLY]: 'Webhook',
  [IntegrationRequestStepId.SYNC_TEST]: 'Copia a test',
  [IntegrationRequestStepId.VERIFY_TEST]: 'Verificación de test',
  [IntegrationRequestStepId.SMOKE_TESTS]: 'Pruebas en test',
};

export type IntegrationStepState = 'ok' | 'failed' | 'skipped';

export interface IntegrationRequestStep {
  id: IntegrationRequestStepId;
  label: string;
  state: IntegrationStepState;
  detail?: unknown;
  error?: string | null;
  at: string;
  by?: string | null;
}

export interface IntegrationPrepareResult {
  commerce: { id: string; name: string; commerceCode: string };
  logisticOperator: { id: string; name: string; logisticOperatorCode: string };
  defaultBranch: { id: string; name: string; apiCode: string; externalBranchCode: string | null };
  credentials: { apiKey: string; apiSecret: string };
  integrationUser: { email: string; loginUrl: string };
  ingestDefaultsApplied: {
    defaultOriginCountryName?: string;
    defaultCommercialServiceCode?: string;
  };
  minimalIngestExample: {
    login: { url: string; body: { username: string; password: string } };
    createShipping: { url: string; body: Record<string, unknown> };
    getConfig: { url: string; query: Record<string, string> };
  };
}

export interface IntegrationRequestResult {
  prepare?: IntegrationPrepareResult;
}

export type IntegrationPackage = Record<string, unknown>;

export interface IntegrationImportResult {
  dryRun: boolean;
  imported: boolean;
  plan: { creates: string[]; updates: string[] };
  missingDependencies: string[];
  conflicts: string[];
  differences: string[];
}

export const TEST_ENVIRONMENT_STEPS = [
  IntegrationRequestStepId.SYNC_TEST,
  IntegrationRequestStepId.VERIFY_TEST,
  IntegrationRequestStepId.SMOKE_TESTS,
];

export interface IntegrationStepRecord {
  id: IntegrationRequestStepId;
  state: IntegrationStepState;
  detail?: unknown;
  error?: string | null;
}
